module.exports = __webpack_public_path__ + "img/cardImg03.75cbb7f9.jpg";